import React, { useState, useEffect, FC } from "react";
import { getLabelData } from "../../../../api/DzoneApi";
import QRCode from "qrcode";
import { generateShippingLabelsPDF } from "../../../../api/pdf";
import createDownloadLink from "../../../../util/createDownloadLink";
import { AdminQuoteObj } from "./TableToolbarProd";

function useToolbarProdSelector(quote: AdminQuoteObj, numSelected: number) {
  const [loadShipLabel, setLoadShipLabel] = useState(false);
  const [loadCnc, setLoadCnc] = useState(false);

  useEffect(() => {
    setLoadShipLabel(false);
    setLoadCnc(false);
  }, [numSelected]);

  const handleClickLabels = async (salesOrder: string) => {
    setLoadCnc(true);
    try {
      const res = await getLabelData(salesOrder);
      if (!res?.data) {
        setLoadCnc(false);
        return;
      }
      createDownloadLink(res.data, `AGMillworks(LS-${salesOrder}).pdf`);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadCnc(false);
    }
  };

  const handleClickShipLabels = async () => {
    if (!quote) return;

    const url =
      process.env.NODE_ENV === "production"
        ? `https://agdealerzone.com/installDetails/${quote._id}`
        : `http://192.168.1.124:3000/installDetails/${quote._id}`;

    setLoadShipLabel(true);

    try {
      const qrSrc = await QRCode.toDataURL(url);
      const res = await generateShippingLabelsPDF({
        quoteId: quote._id,
        qrCode: qrSrc,
      });
      createDownloadLink(
        res.data,
        `AGMillworks(ShippingLabel-${quote.salesOrder}).pdf`
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoadShipLabel(false);
    }
  };

  return {
    handleClickLabels,
    handleClickShipLabels,
    loadCnc,
    loadShipLabel,
  };
}

export default useToolbarProdSelector;